import React, { useEffect, useState, useRef } from "react";
import ArtItem from "./ArtItem";
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { gsurl } from "../gsurl"

// const gsurl = "https://script.google.com/macros/s/AKfycbwMQbBzJhnAxsHa41-5KouEdumYEGkC7Oo2Zt7Q8P8loMmNH3gGgOmWYnJpWZoo2h41aA/exec"

const GalleryText =
    <div className="landing-text text-base mt-4 text-justify mb-5">
        <p className="mt-3">
            Hey, welcome to the Ath "Gallery" page. This page reflects works I have made over the decades.

            Having said that, I am always open to custom making a piece from this page, if you’d like.
        </p>
        <p className="mt-3">
            Again: any questions/comments/critiques are welcome. Feel free to <a href="/contact" >contact me</a>.
        </p>
        <p className="mt-3">
            FYI: A word about the “Fig.” works. If you recall, a lot of your school books (Science, Math, et al) would have photos/diagrams that would
            state “Fig. 7D: The Elements Chart” for example. They were put there to help one understand the text. Those always stayed with me and seeped
            their way into my cranium, then my art work, and became a whole facet of my ongoing work.
        </p>

        <p className="mt-3">Any interest/purchase inqueries/questions, please <a href="mailto:steven.athanas@gmail.com">contact me</a></p>
        <p className="mt-3">
            Enjoy!
        </p>
    </div>


const Gallery = (props) => {
    const [tabledata, setTabledata] = useState([])
    const [tabs, setTabs] = useState([])
    // const [isModalOpen, setIsModalOpen] = useState(false)


    const dataFetched = useRef(false);

    useEffect(() => {
        if (dataFetched.current) return;
        dataFetched.current = true;

        // using google sheets
        // https://www.youtube.com/watch?v=15y1D1mGKdE
        const getTable = async () => {
            // console.log('HERE')
            const res = await fetch(gsurl);
            var { data } = await res.json()
            // clean it up
            data.shift(); // drop the first row
            data = data.filter(x => x.ID !== "");
            // sort the data
            data.sort((a, b) => a.ORDER - b.ORDER)
            // console.log('sorted',data)
            // let xxx = data.map(x=>( {ID:x.ID, IMAGE: x.IMAGE}))
            // console.log(xxx)
            setTabledata(data);
            var xtabs = {}
            data.forEach((row) => {
                xtabs[row.SECTION] = 1;
            })
            setTabs(Object.keys(xtabs))

        };
        getTable();

    }, []);

    var tgroups = {};

    tabs.forEach((tab) => {
        var filtered = tabledata.filter((x) => x.SECTION === tab)
        tgroups[tab] = filtered
    })


    return (
        <div className="container">
            {GalleryText}
            <Tabs>
                <TabList>
                    {tabs.map((tab, idx) =>
                        <Tab key={idx}><p className="text-lg"> {tab}</p></Tab>
                    )}
                </TabList>

                {tabs.map((tab, tidx) =>
                    <TabPanel key={tidx}>
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                            {tgroups[tab].map((item, idx) => (
                                <ArtItem key={idx + tidx * 1000} data={item} />
                            ))}
                        </div>
                    </TabPanel>
                )}
            </Tabs>
        </div>
    );
};

export default Gallery;

